<p class="loggedoutmesssage">
  {{message}}
</p>
<br>
<p class="loggedoutmesssage">{{redirectNotification}}</p>
